<div class="modal-header">
  <h4 class="modal-title">
    {{ mode === 'create' ? 'Добавяне на коментар' : 'Редактиране на коментар' }}
  </h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    [disabled]="loading"
    (click)="closeModal()">
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form">
    <fieldset class="mb-4">
      <label for="content" class="mb-0 form-label">Коментар*</label>
      <textarea
        id="content"
        rows="6"
        formControlName="content"
        class="form-control"
        placeholder="Въведете коментар..."
        aria-label="Коментар"
        [class.is-valid]="content?.touched && content?.valid"
        [class.is-invalid]="content?.touched && content?.invalid"></textarea>
      <p class="invalid-feedback m-0">Задължително поле с максимална дължина от 2000 символа!</p>
    </fieldset>
  </form>
</div>
<div class="modal-footer">
  <button
    type="button"
    [disabled]="loading"
    class="btn btn-outline-secondary"
    (click)="closeModal()">
    <span>Затвори</span>
  </button>
  <button
    type="button"
    [disabled]="loading"
    class="btn btn-nz-primary"
    (click)="onSubmit()">
    @if (loading) {
      <span class="me-2 spinner-border spinner-border-sm"></span>
    }
    <span>Запази</span>
  </button>
</div>
